import { styled } from 'ui/theme';

export const Picture = {
  Component: styled.picture`
    overflow: hidden;

    img {
      max-height: 100%;
      object-fit: cover;
    }
  `,
};
